import * as React from 'react'

import * as hooks from '@owl-nest/hooks'
import * as layout from '@owl-nest/layout'
import * as shadow from '@owl-nest/shadow'
import * as header from '@ulule/header'

import { ActivityCardList, Figures, Hero, Mission } from '../components'
import { AccountCreationBlock } from '../components/AccountCreationBlock'

import { Seo } from './Seo'

export function Discover(): React.ReactElement {
  const router = hooks.useNextRouter()
  const userLocale = router.locale ?? router.defaultLocale

  return (
    <shadow.TrackingProvider
      siteCategory={shadow.SITE.ULULE}
      pageCategory={shadow.CATEGORY.DISCOVER_ULULE}
      userLocale={userLocale}
      gtmContainerId={process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER || ''}
    >
      <Seo userLocale={userLocale} />
      <header.Header lang={userLocale} />
      <Hero userLocale={userLocale} />
      <ActivityCardList userLocale={userLocale} />
      <Mission />
      <Figures />
      <AccountCreationBlock />
      <layout.Footer lang={userLocale} navSections={layout.getNavSectionList(userLocale)} />
    </shadow.TrackingProvider>
  )
}
